import { render } from "./SystemUserAvatar.vue?vue&type=template&id=13f20b2e"
import script from "./SystemUserAvatar.vue?vue&type=script&lang=js"
export * from "./SystemUserAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__